import 'slick-carousel';
import throttle from 'lodash/throttle';

class ListTeaserContainer {
    constructor(elem) {
        this.elem = elem;
        this.breakpoints = {
            'screen-sm': 576,
            'screen-md': 768,
            'screen-lg': 992,
            'screen-xl': 1260,
        };
    }

    init() {
        if ($(this.elem).hasClass('list-teaser-container--slider')) {
            const buttonNextText = $(this.elem).data('slider-button-next');
            const buttonPrevText = $(this.elem).data('slider-button-prev');
            const settings = {
                accessibility: true,
                dots: false,
                mobileFirst: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                rows: 2,
                infinite: true,
                prevArrow: `<button class="slick-prev slick-arrow" type="button">${buttonPrevText}</button>`,
                nextArrow: `<button class="slick-next slick-arrow" type="button">${buttonNextText}</button>`,
                responsive: [
                    {
                        breakpoint: this.breakpoints['screen-md'],
                        settings: 'unslick',
                    },
                    {
                        breakpoint: this.breakpoints['screen-xl'],
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                ],
            };

            const slider = $(this.elem).slick(settings);

            $(window).on('resize', throttle(() => {
                if ($(window).width() > this.breakpoints['screen-md'] && !slider.hasClass('slick-initialized')) {
                    $(this.elem).slick(settings);
                }
            }));
        }
    }
}

export default ListTeaserContainer;
